import React, { useEffect, useState } from 'react'
import {
  AnnotationOverlayContext,
  DraftCommentProvider,
} from 'modules/annotations/components'
import { useLockCamera } from '@sketch-hq/sketch-web-renderer'

interface ArtboardAnnotationsOverlayContextProps
  extends OmitSafe<
    React.ComponentProps<typeof AnnotationOverlayContext>,
    'onMovingAnnotation'
  > {
  shareIdentifier: string
  permanentPageId?: string
  isViewingLatestVersion: boolean
}

export const ArtboardAnnotationsOverlayContext = (
  props: ArtboardAnnotationsOverlayContextProps
) => {
  const lockCamera = useLockCamera()
  const [lockCameraState, setLockCameraState] = useState(false)

  useEffect(() => {
    lockCamera(lockCameraState)
  }, [lockCamera, lockCameraState])

  return (
    <DraftCommentProvider>
      <AnnotationOverlayContext
        onMovingAnnotation={setLockCameraState}
        {...props}
      />
    </DraftCommentProvider>
  )
}
